export enum StepsTopNavigationTheme {
  WithBreadcrumbs = 'withBreadcrumbs',
  WithArrows = 'withArrows',
  None = 'none',
}
